import axios from '../axiosConfig';

export default {
  assignPositiveBalanceSendConfirmation: (request) => axios.post('/internal-receipts/assignPositiveBalance', request)
};
